export default "__VITE_ASSET__4a1be7c2__"